<template>
  <div>
    <div class="loading-splash loading-splash_main">
      <div class="spinner"></div>
    </div>
    <div id="app">
      <router-view/>
    </div>
  </div>
</template>

<script>
import FooterView from '@components/footer/FooterView.vue'
import store from '@store/index.js'

export default {
  components: {
    FooterView
  },
  methods: {
    getSchema () {
      this.request('/get/schema', 'POST', {})
        .then(response => store.commit('setSchema', response))
        .catch(error => console.log('Error get schema', error))
    }
  },
  created() {
    this.getSchema()
  }
}
</script>

<style lang="stylus">
#app
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  //overflow-y auto
</style>
